import { render } from "./PrincipalMenuItem.vue?vue&type=template&id=70742453&ts=true"
import script from "./PrincipalMenuItem.vue?vue&type=script&lang=ts"
export * from "./PrincipalMenuItem.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__